import SummaryMetrics from "../../../../components/Reports/SummaryMetrics";
import { PnlBreakdown } from "../../../../getters/pnlBreakdownGetter/pnlBreakdownTypes";
import { useSummaryMetrics } from "reports/utils/metricUtils";
import { MetricEnum } from "reports/utils/metricTypes";
import { useReportConfig } from "components/DataGetter/FlightConfig/useFlightConfig";

import { getPartsLoss } from "./sbdWarringtonEosUtils";

export default function SbdwarringtonSummaryMetrics({
  data,
  processGroupName,
}: {
  data: PnlBreakdown;
  processGroupName?: string;

  is24Hour?: boolean;
}) {
  const reportConfig = useReportConfig();

  const summaryMetricsRow1 = useSummaryMetrics({
    metrics: reportConfig?.eosReportMetricsConfig?.summaryMetricsRow1 ?? [
      { name: MetricEnum.OEE },
      { name: MetricEnum.AVAIL },
      { name: MetricEnum.PERF },
      {
        name: MetricEnum.TAGGING,
      },
    ],
    pnlBreakdown: data,
    targetsOverride: {},
  });

  const configMetricsRow2 =
    reportConfig?.eosReportMetricsConfig?.summaryMetricsRow2?.map(metric => ({
      ...metric,
      ...(metric.title === "Parts Loss"
        ? { customValue: getPartsLoss(data) }
        : {}),
    }));
  const summaryMetricsRow2 = useSummaryMetrics({
    metrics: configMetricsRow2 ?? [
      { name: MetricEnum.COUNT, title: "Parts Produced" },
      {
        name: MetricEnum.COUNT,
        title: "Parts Loss",
        customValue: getPartsLoss(data),
      },
    ],
    pnlBreakdown: data,
  });
  return (
    <SummaryMetrics
      processGroupName={processGroupName}
      summaryMetrics={[summaryMetricsRow1, summaryMetricsRow2]}
    />
  );
}
